const regExp = /^((?:http(s)?:\/\/)([\w.-]+(?:\.[\w\.-]+)?)[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+\%,;=.]+)$/i;

export const isValidUrl = (url: string = '') => {
  return regExp.test(url);
};
